import React, { useState } from "react";
import { motion } from "framer-motion";
import CustomAction from "../../../../controls/CustomAction";
import { TbCircleDotFilled } from "react-icons/tb";
import Textarea from "@mui/joy/Textarea";

export default function RequiredMedicalQuestions({
  mainColor,
  handleNextStepPC,
  tripCountries,
  tripSelections,
  setTripSelections,
}) {
  const questions = [
    { id: 1, text: "Are you well today?" },
    {
      id: 2,
      text: "Do you have any health conditions or receiving regular treatment or follow-up with your GP / hospital / specialist?",
    },
    {
      id: 3,
      text: "Do you, your parents, brother, sister or child, have epilepsy or seizures?",
    },
    {
      id: 4,
      text: "Have you, your parents, brother, sister or child, ever experienced any mental health issues - even mild anxiety, or depression?",
    },
    {
      id: 5,
      text: "Do you have a condition, have you taken medication or had treatment in the last 12 months that could impair your immune system?",
    },
    { id: 6, text: "Have you ever had surgery?" },
    {
      id: 7,
      text: "Have you ever had a travel-related illness or injury that required treatment or a trip to the hospital?",
    },
    { id: 8, text: "Do you have any allergies?" },
    {
      id: 9,
      text: "Have you or anyone in your family, ever had a severe reaction to a vaccine or malaria medication?",
    },
    { id: 10, text: "Are you pregnant or planning a pregnancy?" },
    { id: 11, text: "Are you breastfeeding?" },
    { id: 12, text: "Are you taking any medications?" },
    { id: 13, text: "Have you had any vaccines in the last 4 weeks?" },
  ];

  const handleOptionsClick = (question, option) => {
    if (
      tripSelections?.requiredMedicalQuestions?.find(
        (q) => q.question === question
      )
    ) {
      setTripSelections((prev) => ({
        ...prev,
        requiredMedicalQuestions: prev.requiredMedicalQuestions?.map((q) =>
          q.question === question ? { question, option } : q
        ),
      }));
    } else {
      setTripSelections((prev) => ({
        ...prev,
        requiredMedicalQuestions: [
          ...(prev.requiredMedicalQuestions || []),
          { question, option },
        ],
      }));
    }
  };
  const handleContinue = () => {
    handleNextStepPC();
  };

  return (
    <motion.div
      initial={{ y: 50, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ type: "spring", stiffness: 100, delay: 0.5 }}
      exit={{ y: 50, opacity: 0 }}
      className="bf-content-wrapper pc-required-questions"
    >
      <div className="bf-content-header">
        <h2 className="bf-title" style={{ color: mainColor }}>
          Required Medical Questions
        </h2>
        <p className="bf-subtitle">
          Why we ask: If you've had certain vaccinations before, you may not
          need boosters or additional shots.
        </p>
      </div>

      <div className="bf-content-body">
        <div className="questions-wrapper">
          {questions.map((question, index) => (
            <div className="question-box" key={index}>
              <p className="question">{question.text}</p>
              <div className="options">
                <div
                  className={`option ${
                    tripSelections?.requiredMedicalQuestions?.find(
                      (q) => q.question === question.text && q.option === "No"
                    )
                      ? "selected"
                      : ""
                  }`}
                  style={{
                    border: tripSelections?.requiredMedicalQuestions?.find(
                      (q) => q.question === question.text && q.option === "No"
                    )
                      ? `1px solid ${mainColor}`
                      : "1px solid #cecece",
                  }}
                  onClick={() => handleOptionsClick(question.text, "No")}
                >
                  <p>No</p>
                  {tripSelections?.requiredMedicalQuestions?.find(
                    (q) => q.question === question.text && q.option === "No"
                  ) ? (
                    <TbCircleDotFilled
                      className="checkmark"
                      color={mainColor}
                      size={22}
                    />
                  ) : (
                    <div className="empty-circle"></div>
                  )}
                </div>
                <div
                  className={`option ${
                    tripSelections?.requiredMedicalQuestions?.find(
                      (q) => q.question === question.text && q.option === "Yes"
                    )
                      ? "selected"
                      : ""
                  }`}
                  style={{
                    border: tripSelections?.requiredMedicalQuestions?.find(
                      (q) => q.question === question.text && q.option === "Yes"
                    )
                      ? `1px solid ${mainColor}`
                      : "1px solid #cecece",
                  }}
                  onClick={() => handleOptionsClick(question.text, "Yes")}
                >
                  <p>Yes</p>
                  {tripSelections?.requiredMedicalQuestions?.find(
                    (q) => q.question === question.text && q.option === "Yes"
                  ) ? (
                    <TbCircleDotFilled
                      className="checkmark"
                      color={mainColor}
                      size={22}
                    />
                  ) : (
                    <div className="empty-circle"></div>
                  )}
                </div>
              </div>

              {question.id === 8 && (
                <Textarea
                  placeholder="You can write your comments here..."
                  className="allergy-textarea"
                  minRows={2}
                  onChange={(e) => {
                    setTripSelections((prev) => ({
                      ...prev,
                      requiredMedicalQuestions:
                        prev.requiredMedicalQuestions?.map((q) =>
                          q.question === question.text
                            ? {
                                ...q,
                                comments: e.target.value,
                              }
                            : q
                        ),
                    }));
                  }}
                />
              )}
            </div>
          ))}
        </div>
        <CustomAction mainColor={mainColor} text={"Continue"} action={handleContinue} />
      </div>
    </motion.div>
  );
}
